import { render, staticRenderFns } from "./VLabeledCheckbox.vue?vue&type=template&id=fb4a9e80&"
import script from "./VLabeledCheckbox.vue?vue&type=script&lang=ts&"
export * from "./VLabeledCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./VLabeledCheckbox.vue?vue&type=style&index=0&id=fb4a9e80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports